import { modulePage } from "../../core/Application";
import { Api, LOADER_FULLPAGE } from "../../core/components/Api";
import { defaultApiClient } from "../../core/components/HttpClient";

export class Newsletter extends Api implements modulePage {
    readonly name: string = "Newsletter";
    
    private modal = document.getElementById("newsletterModal") as HTMLDivElement;
    private emailAddressInput = document.getElementById("newsletter-input") as HTMLInputElement;
    private emailAddressError = document.getElementById("newsletter-input-error") as HTMLInputElement;
    private acceptPrivacyInput = document.getElementById("newsletter-conditions") as HTMLInputElement;
    private formContainer = document.getElementById("newsletter-form-container") as HTMLFormElement;
    private formSubmit = document.getElementById("newsletter-submit") as HTMLDivElement;
    private formConfirmationContainer = document.getElementById("newsletter-form-confirmation") as HTMLDivElement;

    modalEvents = () => {
        this.modal.addEventListener('hidden.bs.modal', () => {
            this.decorateContent(true);
        });
    }

    formEvent = () => {
        this.formSubmit.addEventListener("click", async (e) => {
            this.showLoader({ loader: LOADER_FULLPAGE });
            e.preventDefault();
            if (this.formContainer.checkValidity()) {
                this.emailAddressInput.classList.remove("is-invalid");
                this.emailAddressError.innerHTML = "";
                return await defaultApiClient.request({
                    url: "newsletter/add-email",
                    method: "POST",
                    data: { email: this.emailAddressInput.value }
                })
                    .then((response) => {
                        const data = response.data;
                        if (data.message) {
                            this.decorateContent(false);
                        }
                        this.hideLoader();
                        return data;
                    })
                    .catch((error) => {
                        this.emailAddressInput.classList.add("is-invalid");
                        this.emailAddressError.innerHTML = error.response.message;
                        this.hideLoader();
                    });
            } else {
                this.formContainer.reportValidity();
                this.hideLoader();
            }
        });
    }

    decorateContent = (reset: boolean) => {
        if (reset) {
            this.emailAddressInput.value = "";
            this.acceptPrivacyInput.checked = false;
            this.formSubmit.classList.remove("d-none");
            this.formContainer.classList.remove("d-none");

            this.formConfirmationContainer.classList.add("d-none");

            this.emailAddressInput.classList.remove("is-invalid");
            this.emailAddressError.innerHTML = "";
        } else {
            this.formSubmit.classList.add("d-none");
            this.formContainer.classList.add("d-none");

            this.formConfirmationContainer.classList.remove("d-none");
        }

    }

    init(): void {
        this.modalEvents();
        this.formEvent();
    }
}